import { render, staticRenderFns } from "./ClickableCampaignItem.vue?vue&type=template&id=066633eb&scoped=true&"
import script from "./ClickableCampaignItem.vue?vue&type=script&lang=ts&"
export * from "./ClickableCampaignItem.vue?vue&type=script&lang=ts&"
import style0 from "./ClickableCampaignItem.vue?vue&type=style&index=0&id=066633eb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066633eb",
  null
  
)

export default component.exports